import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { constants } from 'app/constants';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WorkflowStatesService {

  allWorkflowsList: any;

  constructor(
    private http: HttpClient
  ) { }

  createForm() {
    const workflowStatesForm =  new UntypedFormGroup({
      'productGroupName': new UntypedFormControl('', Validators.required),
    });
    for (let i = 0; i < constants.STATE_VALUES_COUNT; i++) {
      workflowStatesForm.addControl('workflowStateColumnValue' + i, new UntypedFormControl(null));
    }
    return workflowStatesForm;
  }

  getAllWorkflowsApi(data: any = {}) {
    return new Promise((resolve, reject) => {
      if (this.allWorkflowsList) {
        resolve(this.allWorkflowsList);
        return;
      }
      const endpointUrl = environment.host_api + 'workflow_state/';
      this.http.request('GET', endpointUrl, {params: data})
      .subscribe(
        response => {
          if (response) {
            console.log('All Workflows Received......');
            this.allWorkflowsList = response;
            resolve(response);
          }
        },
        error => {
          console.log(error.error);
          reject(error.error);
        }
      );
    });
  }

  
  addUpdateWorkflowApi(workflowStatesForm: any, selectedProductGroupData: any, requestMethod: string, data: any = {}) {
    return new Promise((resolve, reject) => {
      const endpointUrl = environment.host_api + 'workflow_state/';

      if (requestMethod !== 'DELETE') {
        data = this.getDataFromForm(workflowStatesForm, selectedProductGroupData, data);
      }
      if (!data) {
        return reject();
      }

      this.http.request(requestMethod, endpointUrl, {body: data})
      .subscribe(
        response => {
          console.log('Workflow States Addeddd......');
          resolve(response);
        },
        error => {
          console.log(error.error);
          reject(error.error);
        }
      );
    });
  }

  getDataFromForm(workflowStatesForm: UntypedFormGroup, selectedProductGroupData: any, data: any) {
    data['user_id'] = sessionStorage.getItem('user_id');
    data['product_grp_id'] = selectedProductGroupData['id'];
    data['product_grp_name'] = selectedProductGroupData['product_grp_name'];
    data['workflow_value'] = this.getWorflowStateValuesInString(workflowStatesForm);
    return data;
  }

  getWorflowStateValuesInString(workflowStatesForm: UntypedFormGroup) {
    let workflowStates : any = [];
    for (let i = 0; i < constants.STATE_VALUES_COUNT; i++) {
      const value = workflowStatesForm.get('workflowStateColumnValue' + i)?.value;
      if (value == null)
      {
        break;
      }
      workflowStates.push(value);
    }
    return workflowStates.join(',');
  }
}
